import styled from 'styled-components';
import { Button as AntDesignButton } from 'antd';
import { AA_LINK_ON_LIGHT, AA_SURFACE } from '~/modules/Helper/contrast.helper';

function primaryBg(theme) {
  return (theme && theme.corTema) || AA_LINK_ON_LIGHT;
}

export const ButtonGoBack = styled(AntDesignButton).attrs({ type: 'primary' })`
  float: left;
  margin: 10px 20px 0 0;

  && {
    margin-left: ${({ ml }) => ml}px;
    margin-right: ${({ mr }) => mr}px;
    color: ${AA_SURFACE};
    background-color: ${({ theme }) => primaryBg(theme)};
    border-color: ${({ theme }) => primaryBg(theme)};
  }

  &&:hover,
  &&:focus {
    color: ${AA_SURFACE};
    background-color: ${({ theme }) => primaryBg(theme)};
    border-color: ${({ theme }) => primaryBg(theme)};
    filter: brightness(0.92);
  }
`;
